"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostUpdate = void 0;
/* eslint-disable @typescript-eslint/adjacent-overload-signatures */
const types_1 = require("@polkadot/types");
const registry_1 = __importDefault(require("../registry"));
class PostUpdate extends types_1.Struct {
    constructor(value) {
        super(registry_1.default, {
            space_id: 'Option<u64>',
            content: 'Option<Content>',
            hidden: 'Option<bool>'
        }, value);
    }
    get content() {
        return this.get('content');
    }
    set content(value) {
        this.set('content', value);
    }
}
exports.PostUpdate = PostUpdate;
